import { ReactNode, isValidElement } from 'react'

export const isReactNodeHelperText = (
  x:
    | ReactNode
    | {
        text: ReactNode
        alt?: ReactNode
      },
): x is ReactNode => {
  return isValidElement(x)
}

export const isReactNodeLabel = (
  x:
    | ReactNode
    | {
        title: ReactNode
        alt?: ReactNode
      },
): x is ReactNode => {
  return isValidElement(x)
}
